'use client';

import { c as _c } from "react/compiler-runtime";
import { useState, useEffect } from 'react';
export function useThemeSync(propIsDark) {
  const $ = _c(6);
  const [isDark, setIsDark] = useState(propIsDark ?? true);
  const [isHydrated, setIsHydrated] = useState(false);
  let t0;
  let t1;
  if ($[0] !== propIsDark) {
    t0 = () => {
      if (propIsDark !== undefined) {
        setIsDark(propIsDark);
        document.body.setAttribute("data-theme", propIsDark ? "dark" : "light");
        setIsHydrated(true);
        return;
      }
      const sessionTheme = sessionStorage.getItem("hero-is-dark");
      let currentTheme;
      if (sessionTheme !== null) {
        currentTheme = sessionTheme === "true";
      } else {
        currentTheme = Math.random() > 0.5;
        sessionStorage.setItem("hero-is-dark", String(currentTheme));
      }
      setIsDark(currentTheme);
      setIsHydrated(true);
    };
    t1 = [propIsDark];
    $[0] = propIsDark;
    $[1] = t0;
    $[2] = t1;
  } else {
    t0 = $[1];
    t1 = $[2];
  }
  useEffect(t0, t1);
  let t2;
  if ($[3] !== isDark || $[4] !== isHydrated) {
    t2 = {
      isDark,
      isHydrated
    };
    $[3] = isDark;
    $[4] = isHydrated;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  return t2;
}